export const requesterFirebaseDesigns = async (url:string)=>{
    const responseBody = await fetch(url);
    const text = await responseBody.text();
    return JSON.parse(JSON.parse(text));
}

export const requesterPatternDesigns = async (url:string)=>{
    const responseBody = await fetch(url);
    return await responseBody.json();
}